import React, { useEffect, useRef } from "react";
import "../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import logo from "../assets/Aspiron-Logo.jpg";
import "./Navbar.css";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import {
  Close,
  Home as HomeIcon,
  Info as InfoIcon,
  Work as WorkIcon,
  Call as CallIcon,
  ArrowRight,
} from "@mui/icons-material";

const Menubar = () => {
  const [menuVisible, setMenuVisible] = useState(false);
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  const [isSubMenuOpen1, setIsSubMenuOpen1] = useState(false);

  const menuRef = useRef(null);
  const menuRef1 = useRef(null);

  const toggleSubMenu = () => {
    setIsSubMenuOpen((prev) => !prev);
  };

  const closeSubMenu = () => {
    setIsSubMenuOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        closeSubMenu();
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  const toggleSubMenu1 = () => {
    setIsSubMenuOpen1((prev) => !prev);
  };

  const closeSubMenu1 = () => {
    setIsSubMenuOpen1(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef1.current && !menuRef1.current.contains(event.target)) {
        closeSubMenu1();
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const toggleMenu = () => {
    setMenuVisible(!menuVisible);
    const navLinks = document.querySelector(".mobile-nav-links");
    if (navLinks) {
      navLinks.classList.toggle("active");
    }
  };

  const location = useLocation();
  document.querySelectorAll(".nav-links li").forEach((menuItem) => {
    menuItem.addEventListener("mouseenter", () => {
      const dropMenu = menuItem.querySelector(".drop-menu");
      if (dropMenu) {
        const rect = dropMenu.getBoundingClientRect();
        const isOverflowingRight = rect.right > window.innerWidth;
        const isOverflowingLeft = rect.left < 0;

        if (isOverflowingRight) {
          dropMenu.classList.add("drop-menu-align-right");
        } else if (isOverflowingLeft) {
          dropMenu.style.left = "0";
          dropMenu.classList.remove("drop-menu-align-right");
        } else {
          dropMenu.classList.remove("drop-menu-align-right");
        }
      }
    });
  });

  return (
    <>
      <nav>
        <div className="wrapper">
          <div className="logo">
            <div className="logo_img">
              <a href="/">
                <img src={logo} alt="Logo" />
              </a>
            </div>
          </div>

          <ul className="nav-links">
            <li>
              <a
                href="/"
                className={`${location.pathname === "/" ? "active1" : ""}`}
              >
                Home
              </a>
            </li>

            <li>
              <a
                href="#"
                className={
                  location.pathname === "/erp" ||
                  location.pathname === "/exam" ||
                  location.pathname === "/wallet" ||
                  location.pathname === "/naac" ||
                  location.pathname === "/obe" ||
                  location.pathname === "/nirf" ||
                  location.pathname === "/iqac" ||
                  location.pathname === "/smart"
                    ? "active1"
                    : "desktop-item"
                }
              >
                Our Innovations
              </a>
              {/* <input type="checkbox" id="showDrop" />
              <label for="showDrop" className="mobile-item">
                Our Products
              </label> */}
              <div>
                <ul
                  className="drop-menu"
                  style={{ display: "flex", gap: "4px" }}
                >
                  <div>
                    {[
                      { path: "/erp", label: "ERP" },
                      { path: "/exam", label: "Digital Evaluation" },
                      { path: "/wallet", label: "Digital Wallet" },
                      { path: "/naac", label: "NAAC" },
                      { path: "/alumniData", label: "Alumni" },
                      {
                        path: "/LearningManagementSystem",
                        label: "Learning Management System (LMS)",
                      },
                      {
                        path: "https://www.youtube.com/playlist?list=PLc4aqdRqNFJpOo0gg9x2inmetXZp8JnpH",
                        label: "View Our Product Demos",
                        external: true,
                      },
                    ].map(({ path, label, external }) => (
                      <li key={label}>
                        <a
                          href={path}
                          className={location.pathname === path ? "active" : ""}
                          style={{ whiteSpace: "nowrap" }}
                          target={external ? "_blank" : ""}
                          rel={external ? "noopener noreferrer" : ""}

                        >
                          {label}
                        </a>
                      </li>
                    ))}
                  </div>
                  <div>
                    {[
                      { path: "/obe", label: "OBE" },
                      { path: "/nirf", label: "NIRF" },
                      { path: "/iqac", label: "IQAC Dashboard" },
                      { path: "/smart", label: "Smart Attendance" },
                      
                    ].map(({ path, label }) => (
                      <li key={label}>
                        <a
                          href={path}
                          className={location.pathname === path ? "active" : ""}
                          style={{ whiteSpace: "nowrap" }}
                        >
                          {label}
                        </a>
                      </li>
                    ))}
                  </div>
                </ul>
              </div>
            </li>

            <li>
              <a
                href="#"
                className={
                  location.pathname === "/about" ||
                  location.pathname === "/careers" ||
                  location.pathname === "/locate"
                    ? "active1"
                    : "desktop-item"
                }
              >
                Explore Aspiron
              </a>
              {/* <input type="checkbox" id="showDrop" />
              <label for="showDrop" className="mobile-item">
                Discover Us
              </label> */}
              <ul className="drop-menu">
                {[
                  { path: "/about", label: "About" },
                  { path: "/careers", label: "Join Us" },
                  { path: "/locate", label: "Locate Us" },
                  { path: "/blogs", label: "Information Hub" },
                ].map(({ path, label }) => (
                  <li key={label}>
                    <a
                      href={path}
                      className={location.pathname === path ? "active" : ""}
                      style={{ whiteSpace: "nowrap" }}
                      rel="noreferrer" 

                    >
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </li>

            <li>
              <a href="https://wa.link/ep3os0" target="_blank"  rel="noreferrer" 
              >
                Let’s Connect
              </a>
            </li>
            {/* <li>
              <a
                href="https://calendly.com/aspiron-technologies1/30min"
                target="_blank"
                rel="noreferrer" 

                style={{
                  fontSize: "15px",
                  backgroundColor: "#FF9800",
                  color: "black",
                  fontWeight: "bold",
                }}
              >
                See It in Action
              </a>
            </li> */}
          </ul>

          <div className="mobile-menu">
            <a
              className="btn menu-btn"
              onClick={toggleMenu}
              style={{
                cursor: "pointer",
                display: "inline-block",
                padding: "5px 10px",
                backgroundColor: "#FF9800",
                color: "black",
                borderRadius: "10px",
                position: "fixed",
                top: "7px",
                right: "10px",
                marginRight: "20px",
              }}
            >
              <i className="fas fa-bars"></i>
            </a>
            <ul
              className={`mobile-nav-links ${menuVisible ? "active" : ""}`}
              style={{
                position: "fixed",
                top: 0,
                right: menuVisible ? "0" : "-300px",
                width: "300px",
                height: "100vh",
                backgroundColor: "#fff",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
                transition: "right 0.3s ease-in-out",
                padding: "10px",
                overflowY: "auto",
                zIndex: 1500,
                display: "flex",
                flexDirection: "column",
                fontFamily: "'Arial', sans-serif",
                boxSizing: "border-box",
                minHeight: "100vh",
                borderRight: "1px solid #ddd",
              }}
            >
              <Close
                onClick={toggleMenu}
                style={{
                  alignSelf: "flex-end",
                  marginBottom: "2px",
                  fontSize: "24px",
                  fontWeight: "bold",
                  color: "red",
                  cursor: "pointer",
                  marginRight: "20px",
                }}
              />

              <li>
                <a
                  href="/"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "6px 2px",
                    color: location.pathname === "/" ? "#FF9800" : "#333",
                    textDecoration: "none",
                    fontWeight: location.pathname === "/" ? "bold" : "normal",
                  }}
                >
                  <HomeIcon style={{ marginRight: "10px" }} />
                  Home
                </a>
              </li>

              <li ref={menuRef}>
                <a
                  href="#"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "6px 2px",
                    color: location.pathname.includes("/our-innovations")
                      ? "#FF9800"
                      : "#333",
                    textDecoration: "none",
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    toggleSubMenu();
                  }}
                >
                  <InfoIcon style={{ marginRight: "10px" }} />
                  Our Innovations
                </a>
                {isSubMenuOpen && (
                  <ul style={{ paddingLeft: "20px", marginTop: "10px" }}>
                    {[
                      { path: "/erp", label: "ERP" },
                      { path: "/exam", label: "Digital Evaluation" },
                      { path: "/wallet", label: "Digital Wallet" },
                      { path: "/naac", label: "NAAC" },
                      // { path: "/alumniData", label: "Alumni" },
                      // {
                      //   path: "/LearningManagementSystem",
                      //   label: "Learning Management System (LMS)",
                      // },
                      { path: "/obe", label: "OBE" },
                      { path: "/nirf", label: "NIRF" },
                      { path: "/iqac", label: "IQAC Dashboard" },
                      { path: "/smart", label: "Smart Attendance" },
                      { path: "/alumniData", label: "Alumni" },
                      { path: "/LearningManagementSystem", label: "Learning Management System (LMS)" },
                      {
                        path: "https://www.youtube.com/playlist?list=PLc4aqdRqNFJpOo0gg9x2inmetXZp8JnpH",
                        label: "View Our Product Demos",
                        external: true,
                      },
                    ].map(({ path, label, external }) => (
                      <li key={label}>
                        <a
                          href={path}
                          style={{
                            display: "block",
                            padding: "2px 0",
                            color:
                              location.pathname === path ? "#FF9800" : "#333",
                            textDecoration: "none",
                          }}
                          target={external ? "_blank" : ""}
                          rel={external ? "noopener noreferrer" : ""}

                        >
                          <ArrowRight style={{ marginRight: "10px" }} /> {label}
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </li>

              <li ref={menuRef1}>
                <a
                  href="#"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "6px 2px",
                    color: location.pathname.includes("/explore-aspiron")
                      ? "#FF9800"
                      : "#333",
                    textDecoration: "none",
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    toggleSubMenu1();
                  }}
                >
                  <WorkIcon style={{ marginRight: "10px" }} />
                  Explore Aspiron
                </a>
                {isSubMenuOpen1 && (
                  <ul style={{ paddingLeft: "20px", marginTop: "10px" }}>
                    {[
                      { path: "/about", label: "About" },
                      { path: "/careers", label: "Join Us" },
                      { path: "/locate", label: "Locate Us" },
                      { path: "/blogs", label: "Information Hub" },
                    ].map(({ path, label }) => (
                      <li key={label}>
                        <a
                          rel="noreferrer" 
                          href={path}
                          style={{
                            // display: "block",
                            padding: "6px 0",
                            color:
                              location.pathname === path ? "#FF9800" : "#333",
                            textDecoration: "none",
                          }}
                        >
                          <ArrowRight style={{ marginRight: "10px" }} /> {label}
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </li>

              <li>
                <a
                  href="https://wa.link/ep3os0"
                  target="_blank"
                  rel="noreferrer" 
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "6px 2px",
                    color: "#333",
                    textDecoration: "none",
                  }}
                >
                  <CallIcon style={{ marginRight: "10px" }} />
                  Let’s Connect
                </a>
              </li>

              <li>
                <a
                  href="https://calendly.com/aspiron-technologies1/30min"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: "block",
                    padding: "12px 20px",
                    fontSize: "15px",
                    backgroundColor: "#FF9800",
                    color: "black",
                    fontWeight: "bold",
                    textAlign: "center",
                    borderRadius: "5px",
                    textDecoration: "none",
                  }}
                >
                  See It in Action
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Menubar;